import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import Button from "Common/Button";

export default function AddToCartButton({ addPlanToCart, planType, plan }) {
  const label = planType === "dental" || planType === "vision" ? "Add Plan" : "Get Started";
  return (
    <Button
      fullWidth
      size="medium"
      className={classnames("select-plan-button start-application")}
      onClick={(event) => {
        handleOnClickAddToCart(addPlanToCart, planType, plan, event);
      }}
    >
      {label}
    </Button>
  );
}

function handleOnClickAddToCart(addPlanToCart, planType, plan, event) {
  event.stopPropagation();
  addPlanToCart({ planType, plan });
}

AddToCartButton.propTypes = {
  addPlanToCart: PropTypes.func.isRequired,
  planType: PropTypes.string.isRequired,
  plan: PropTypes.object.isRequired,
};
